<template>
  <form :class="['file-upload', { ['file-upload__disabled']: loading }]" @submit.prevent="uploadFile">
    <label class="file-upload__label">file must be less 10 MB</label>
    <input
        ref="fileUpload"
        type="file"
        name="file-upload"
        id="file-upload"
        class="file-upload__input"
        @change="selectFile"
    />
    <loading-icon v-if="loading"></loading-icon>
    <input
        v-else
        type="submit"
        name="commit"
        value="upload file"
        :class="['button file-upload__submit', { ['file-upload__disabled']: !selectedFile }]"
    />
  </form>
</template>

<script>
  import AxiosMixin from '../mixins/AxiosMixin'
  import LoadingIcon from '../Shared/LoadingIcon'
  import { mapGetters } from "vuex";

  export default {
    props: {
      currentAdvertiser: Object,
    },

    name: 'FileUpload',

    mixins: [AxiosMixin],

    components: {
      LoadingIcon
    },

    data() {
      return {
        loading: false,
        maxFileSize: 1024 * 1024 * 10, // 10 mb
        selectedFile: null,
      }
    },

    computed: {
      ...mapGetters(['brandId'])
    },

    methods: {
      onError(error) {
        this.$emit('setMessage', `error uploading file: ${error}`, 'error')
        this.resetFileForm()
      },

      onSuccess() {
        this.resetFileForm()
        this.$emit('loadFiles')
        this.$emit('setMessage', null, 'error')
        this.$emit('setMessage', 'successfully added file', 'success')
      },

      resetFileForm() {
        this.$refs.fileUpload.value = null
        if (this.loading) { this.loading = false }
        if (this.selectedFile) { this.selectedFile = null }
      },

      selectFile(event) {
        const files = event?.target?.files,
          file = files ? files[0] : null

        if (!file) { return this.$emit('setMessage', null, 'error') }

        if (file.size < this.maxFileSize) {
          this.$emit('setMessage', null, 'error')
          this.selectedFile = file
        } else {
          this.onError('file is too large, select a file under 10mb')
        }
      },

      uploadFile() {
        if (!this.selectedFile) { return }
        this.loading = true
        const config = {'Content-Type': 'multipart/form-data'},
          methodType = 'post',
          url = '/attachments',
          file = this.$refs.fileUpload.files[0]
        let params = new FormData()
        params.append('file', file)
        params.append('label', 'file_uploads')
        params.append('brand_id', this.brandId)
        this.axiosMethod({methodType, url, params, config, onSuccess: this.onSuccess, onError: this.onError})
      },
    },
  }
</script>

<style lang="sass">
  @import '../../assets/sass/colors'

  .file-upload
    text-align: left

    &__label,
    &__input,
    &__submit
      display: block

    &__error
      color: $negative-hover
      font-size: 0.9em

    &__input
      border: none
      border-radius: 0
      cursor: pointer
      margin: 0
      padding-left: 0

    &__label
      padding-bottom: 0.35rem

    &__disabled
      opacity: 0.5
      pointer-events: none

    .loading-icon
      margin: 0 0 0 3em

    &__submit
      outline: none
      width: 150px

</style>